<template>
  <!-- page1 -->
  <div class="width-100 height-100 content " id="card1">
    <audio :src="audiosrc" ref="audio" autoplay="autoplay"></audio>
    <video
      class="end_video"
      src="video/endvideo90s.mov"
      muted
      width="100%"
      height="100%"
      ref="endVideo"
    ></video>
  </div>
</template>
<script>
export default {
  name: "OneComponent",
  data: function () {
    return {
      audiosrc: "",
      audioData: {},
    };
  },

  props: {
    tempAduioArr: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    tempAduioArr: {
      handler(val) {
        if (val.length > 0) {
          this.audioData = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {},
  methods: {
    // 页面card一个接一个播放
    async playCardStart() {
      this.audiosrc = this.audioData[13].audio_link;
      this.$nextTick(() => {
        this.$refs["audio"].play();
      });
      setTimeout(() => {
        this.$emit("playEnd");
      }, this.getTime().pageLen * 1000);

      await this.playPage1();
    },
    async playPage1() {
      this.$refs.endVideo.play();
    },
    getTime() {
      let time = 4; 
      let audioTime = Math.ceil(this.audioData[13].audio_length);
      if (audioTime > time) {
        time = audioTime;
      }
      return {
        audio_link: this.audioData[13].audio_link,
        pageLen: time,
      };
    },
  },
};
</script>
<style scoped lang="less">
#card1 {
  background: url("../../assets/img/90s/bg.png");
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;

}
</style>

